import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router';

import { REGION_SEASON_STORAGE_KEY } from '@/contexts/region-season-context/constants';

import { useAuth } from './auth.context';
import { decodeRedirectState } from './utils';

function AuthContainer() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { signin } = useAuth();

  useEffect(() => {
    const setLoading = () => {
      localStorage.removeItem(REGION_SEASON_STORAGE_KEY);
    };
    signin(location, () => {
      const from = location.state?.from?.pathname || '/';
      const code = searchParams.get('code');
      const state = searchParams.get('state');

      if (state) {
        setLoading();
        void navigate(decodeRedirectState(state) ?? from, { replace: true });
      } else if (code) {
        setLoading();
        void navigate(from, { replace: true });
      } else {
        void navigate(from + location.search, { replace: true });
      }
    });
  }, [signin, location, navigate, searchParams]);

  return undefined;
}

export default AuthContainer;
